import { atom, selector } from 'recoil'
import Update = Models.Update
import { updateStatusString } from '../../../constants/update_status'
import { bgColors } from '../../../components/pie-chart'
import { ChartData } from 'chart.js'
import Snapshot = Models.Snapshot
import { UpdateStatuses } from '../../../config'
import Report = Models.Report
import Export = Models.Export

export const updateDetailsAtom = atom<null | Update>({
    key: 'update_details_raw',
    default: null,
})

export const unsuccessfulSnapshots = selector<Snapshot[]>({
    key: 'update_details_unsuccessful_snapshots',
    get: ({ get }) => {
        const update = get(updateDetailsAtom)
        if (!update) {
            return []
        }

        return update.snapshots.filter((snapshot) => {
            return snapshot.status_id !== UpdateStatuses.Success
        })
    },
})

export const unsuccessfulReports = selector<Report[]>({
    key: 'update_details_unsuccessful_reports',
    get: ({ get }) => {
        const update = get(updateDetailsAtom)
        if (!update) {
            return []
        }

        return update.reports.filter((report) => {
            return report.status_id !== UpdateStatuses.Success
        })
    },
})

export const unsuccessfulExports = selector<Export[]>({
    key: 'update_details_unsuccessful_exports',
    get: ({ get }) => {
        const update = get(updateDetailsAtom)
        if (!update) {
            return []
        }

        return update?.exports ?? []
    },
})

export const snapshotPieData = selector<ChartData<'pie'>>({
    key: 'update_details_snapshot_selector',
    get: ({ get }) => {
        const update = get(updateDetailsAtom)
        return buildPieData(update, 'snapshots', 'Snapshots by Status')
    },
})

export const reportPieData = selector<ChartData<'pie'>>({
    key: 'update_details_report_selector',
    get: ({ get }) => {
        const update = get(updateDetailsAtom)
        return buildPieData(update, 'reports', 'Reports by Status')
    },
})

export const exportPieData = selector<ChartData<'pie'>>({
    key: 'update_details_export_selector',
    get: ({ get }) => {
        const update = get(updateDetailsAtom)
        return buildPieData(update, 'exports', 'Exports by Status')
    },
})

const buildPieData = (
    update: Update | null,
    key: 'snapshots' | 'reports' | 'exports',
    label: string,
): ChartData<'pie'> => {
    const itemStatuses: { [key: string]: number } = {}
    if (update) {
        const items = update[key]
        items.forEach((snapshot) => {
            const state = updateStatusString(snapshot.status_id)

            if (!itemStatuses[state]) {
                itemStatuses[state] = 0
            }
            itemStatuses[state] += 1
        })
    }

    const bg: string[] = []
    const border: string[] = []
    Object.keys(itemStatuses).forEach((_, i) => {
        bg.push(bgColors[i])
        border.push(bgColors[i])
    })

    return {
        labels: Object.keys(itemStatuses),
        datasets: [
            {
                label,
                data: Object.values(itemStatuses),
                backgroundColor: bg,
                borderColor: border,
                borderWidth: 1,
            },
        ],
    }
}
